import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'

export const LOCATION = `
...on location_Entry {
  id
  typeHandle

  headingAdvanced {
    html
  }
  
  locationPosition
  backgroundColor
  sidebarBackgroundColor

  ${ IMAGE_DESKTOP }
  ${ IMAGE_MOBILE }

  header
  col1Name
  col2Name
  col3Name
  col1Value
  col2Value
  col3Value

  linkTitle {
    url
    title
    target
  }
}
`